// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cleaningProcedureId } from './CleaningProcedure';
import { cleaningFieldKindEnum } from './CleaningFieldKindEnum';
import { cleaningTextInputModeEnum } from './CleaningTextInputModeEnum';
import { invResourceId } from './InvResource';
import { invResourceCategoryId } from './InvResourceCategory';
import { operatorId } from './Operator';
import { cpLevelEnum } from './CpLevelEnum';
import { templateAttributeRole } from './TemplateAttributeRole';
import { z } from 'zod';
export const cleaningFieldId = (z.number());
export const cleaningField = z.object({
    id: cleaningFieldId,
    procedure_id: cleaningProcedureId,
    name: z.string(),
    code: z.string(),
    kind: cleaningFieldKindEnum,
    is_optional: z.boolean(),
    number_unit: z.string().nullable(),
    number_min: z.string().nullable(),
    number_max: z.string().nullable(),
    number_precision: z.number().nullable(),
    text_input_mode: cleaningTextInputModeEnum.nullable(),
    text_options: z.unknown().nullable(),
    inv_resource_id: invResourceId.nullable(),
    inv_resource_category_id: invResourceCategoryId.nullable(),
    computed_formula: z.string().nullable(),
    computed_unit: z.string().nullable(),
    computed_precision: z.number().nullable(),
    is_archived: z.boolean(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    is_control_point: z.boolean(),
    cp_level: cpLevelEnum.nullable(),
    cp_details: z.string().nullable(),
    cp_default_number_target: z.string().nullable(),
    cp_default_number_abs_tol_lower: z.string().nullable(),
    cp_default_number_abs_tol_upper: z.string().nullable(),
    cp_default_number_rel_tol_lower: z.string().nullable(),
    cp_default_number_rel_tol_upper: z.string().nullable(),
    cp_default_number_unit: z.string().nullable(),
    cp_default_check_value: z.boolean().nullable(),
    role: templateAttributeRole,
    default_value_number: z.string().nullable(),
    default_value_measurement_unit: z.string().nullable(),
    default_check_value: z.boolean().nullable(),
    display_order: z.number(),
});
export const cleaningFieldInitializer = z.object({
    id: cleaningFieldId.optional(),
    procedure_id: cleaningProcedureId,
    name: z.string(),
    code: z.string(),
    kind: cleaningFieldKindEnum,
    is_optional: z.boolean().optional(),
    number_unit: z.string().optional().nullable(),
    number_min: z.string().optional().nullable(),
    number_max: z.string().optional().nullable(),
    number_precision: z.number().optional().nullable(),
    text_input_mode: cleaningTextInputModeEnum.optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    inv_resource_id: invResourceId.optional().nullable(),
    inv_resource_category_id: invResourceCategoryId.optional().nullable(),
    computed_formula: z.string().optional().nullable(),
    computed_unit: z.string().optional().nullable(),
    computed_precision: z.number().optional().nullable(),
    is_archived: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    is_control_point: z.boolean().optional(),
    cp_level: cpLevelEnum.optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_default_number_target: z.string().optional().nullable(),
    cp_default_number_abs_tol_lower: z.string().optional().nullable(),
    cp_default_number_abs_tol_upper: z.string().optional().nullable(),
    cp_default_number_rel_tol_lower: z.string().optional().nullable(),
    cp_default_number_rel_tol_upper: z.string().optional().nullable(),
    cp_default_number_unit: z.string().optional().nullable(),
    cp_default_check_value: z.boolean().optional().nullable(),
    role: templateAttributeRole.optional(),
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional(),
});
export const cleaningFieldMutator = z.object({
    id: cleaningFieldId.optional(),
    procedure_id: cleaningProcedureId.optional(),
    name: z.string().optional(),
    code: z.string().optional(),
    kind: cleaningFieldKindEnum.optional(),
    is_optional: z.boolean().optional(),
    number_unit: z.string().optional().nullable(),
    number_min: z.string().optional().nullable(),
    number_max: z.string().optional().nullable(),
    number_precision: z.number().optional().nullable(),
    text_input_mode: cleaningTextInputModeEnum.optional().nullable(),
    text_options: z.unknown().optional().nullable(),
    inv_resource_id: invResourceId.optional().nullable(),
    inv_resource_category_id: invResourceCategoryId.optional().nullable(),
    computed_formula: z.string().optional().nullable(),
    computed_unit: z.string().optional().nullable(),
    computed_precision: z.number().optional().nullable(),
    is_archived: z.boolean().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    is_control_point: z.boolean().optional(),
    cp_level: cpLevelEnum.optional().nullable(),
    cp_details: z.string().optional().nullable(),
    cp_default_number_target: z.string().optional().nullable(),
    cp_default_number_abs_tol_lower: z.string().optional().nullable(),
    cp_default_number_abs_tol_upper: z.string().optional().nullable(),
    cp_default_number_rel_tol_lower: z.string().optional().nullable(),
    cp_default_number_rel_tol_upper: z.string().optional().nullable(),
    cp_default_number_unit: z.string().optional().nullable(),
    cp_default_check_value: z.boolean().optional().nullable(),
    role: templateAttributeRole.optional(),
    default_value_number: z.string().optional().nullable(),
    default_value_measurement_unit: z.string().optional().nullable(),
    default_check_value: z.boolean().optional().nullable(),
    display_order: z.number().optional(),
});
//# sourceMappingURL=CleaningField.js.map